export const handleMobileFilterBodyClass = (open: boolean, isWiderThanMd?: boolean) => {
  if (isWiderThanMd) {
    return;
  }
  const body = document.querySelector('body');
  if (open) {
    body?.classList.add('PlpModal__Body--open');
  } else {
    body?.classList.remove('PlpModal__Body--open');
  }
};
